import React, { useEffect, useState } from 'react';
import { fetchHomeProfile } from '@/services/omsHome';

const HeaderAccountInfo: React.FC = () => {
  const [profile, setProfile] = useState<{
    uid?: number;
    comid?: string;
    uname?: string;
  }>({});

  useEffect(() => {
    let alive = true;
    fetchHomeProfile().then((res) => {
      if (alive && res) {
        setProfile(res);
      }
    });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="header-account-info">
      <span>我的帐户ID: {profile.uname || '--'}</span>
      <span>我的邀请码: {profile.uid || '--'}</span>
      <span>我的公司编码: {profile.comid || '--'}</span>
    </div>
  );
};

export default HeaderAccountInfo;
